import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';

export const attributionApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    sendAttributionTouch: builder.mutation<
      ApiAttributionTouchResponse,
      ApiAttributionTouchRequestData
    >({
      query: (body) => ({
        url: '/v3/attribution/touch',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSendAttributionTouchMutation } = attributionApi;
